import { FadeIn } from '@/components/templates/blocks/FadeIn.js'
import { Container, Text } from '@/components/ui/index.js'
import styles from './PreviewSection.module.css'

export function PreviewSection() {
  return (
    <section className={styles.section}>
      <Container size="md">
        <FadeIn>
          <Text variant="heading-lg" align="center" className={styles.heading}>
            실제 청첩장 미리보기
          </Text>
        </FadeIn>
        <FadeIn>
          <div className={styles.phoneFrame}>
            <img
              src="/assets/landing/preview-sample.webp"
              alt="청첩장 샘플 미리보기"
              className={styles.previewImage}
              onError={(e) => {
                const target = e.currentTarget
                target.style.display = 'none'
                target.parentElement?.classList.add(styles.placeholder ?? '')
              }}
            />
          </div>
        </FadeIn>
      </Container>
    </section>
  )
}
